import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { LogistikComponentSidebar } from '@chancenlogistik/client/components/logistik-component-sidebar.js';
import { ChromiumDialog } from '@chancenwerk/client/design/components/cr-dialog.js';
import { LogistikSchoolAccessToken } from '@chancenwerk/db/tokens.js';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { switchMap } from 'rxjs';
import { activeToken } from '../globalSubjects.js';

/**
 * @element hefte-component-sidebar
 */
@customElement('hefte-component-sidebar')
export class HefteComponentSidebar extends LogistikComponentSidebar {
  @state() private _tokenInfo = new RXController(this, activeToken, token$ =>
    token$.pipe(
      switchMap(token =>
        LogistikSchoolAccessToken.getByToken<LogistikSchoolAccessToken>(+token)(LogistikSchoolAccessToken.allFields),
      ),
    ),
  );

  protected override _publicPages() {
    return html`
      <cr-sidebar-item
        icon=" "
        text=${'Übersicht'}
        href="/"
        ${css({ color: 'white' })}
        .validateActive=${currentHref => currentHref === '/'}
      >
      </cr-sidebar-item>
    `;
  }

  protected override _authenticatedPages() {
    return nothing;
  }

  protected override _bottomUpperSlot() {
    return html`
      ${this._tokenInfo.value?.maxOrderQuantity
        ? html`
            <cr-text ${css({ color: 'white', textAlign: 'center' })} slot="bottom-upper">
              maximale Bestellmenge:<br />${this._tokenInfo.value.maxOrderQuantity} CHANCENhefte
            </cr-text>
          `
        : nothing}
      ${super._bottomUpperSlot()}
    `;
  }

  protected override _footerButtonsSlot() {
    return html`
      <cr-flex
        slot="footer-buttons"
        center
        crossaxis-center
        ${css({
          flex: 3,
          color: 'white',
          border: '1px solid white',
          cursor: 'pointer',
          borderRadius: this.sizes.borderRadius,
        })}
        @click=${async () => {
          if (
            !(await ChromiumDialog.confirm('Du bist im Begriff dich abzumelden. Forfahren?', {
              highlightDecline: true,
              acceptText: 'Jetzt Abmelden!',
              declineText: 'Abbrechen',
            }))
          )
            return;
          activeToken.next('');
        }}
        padding="sm"
      >
        <cr-icon>logout </cr-icon>
        <cr-tooltip>
          <cr-text> Abmelden </cr-text>
        </cr-tooltip>
      </cr-flex>
    `;
  }
}
